import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconBack10Style0 = cosmosIconCss;

const CosmosIconBack10$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBack10 extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '49a674e0e390f7907012283e82a87985cbc5475f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4c0d941eebca5be347ea7530d21bbf01e7681f74', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4c6213d5f61a371795881ef2c45a3f0847fe51e5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 6.472h4.628a5.11 5.11 0 0 1 5.162 4.824 4.852 4.852 0 0 1-1.362 3.562 5 5 0 0 1-2.841 1.493.509.509 0 0 1-.587-.5v-.532a.51.51 0 0 1 .425-.493c.73-.137 1.4-.49 1.926-1.015a3.323 3.323 0 0 0 .939-2.473 3.6 3.6 0 0 0-3.662-3.362H9v2.3a.5.5 0 0 1-.854.352L5.114 7.576a.5.5 0 0 1 0-.706l3.033-3.024A.5.5 0 0 1 9 4.2v2.272Zm.19 6.846c.312-.3.738-.453 1.169-.418a1.5 1.5 0 0 1 1.62 1.567V15.7a1.5 1.5 0 0 1-1.62 1.571A1.507 1.507 0 0 1 8.732 15.7v-1.229c-.02-.432.147-.852.459-1.153Zm1.594 2.361c0 .349-.143.531-.425.531-.282 0-.431-.187-.431-.531v-1.187c0-.344.143-.532.431-.532.288 0 .425.182.425.532v1.187ZM8.309 16.95v-.621a.231.231 0 0 0-.24-.239h-.46v-2.87a.23.23 0 0 0-.24-.24h-.61a.85.85 0 0 0-.23.03l-1.05.33a.234.234 0 0 0-.16.29l.14.53a.235.235 0 0 0 .32.17l.64-.2v1.96h-.66a.23.23 0 0 0-.24.24v.62a.231.231 0 0 0 .24.24h2.31a.231.231 0 0 0 .24-.24Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconBack10Style0; }
}, [1, "cosmos-icon-back-10", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-back-10"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-back-10":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBack10$1);
            }
            break;
    } });
}

const CosmosIconBack10 = CosmosIconBack10$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBack10, defineCustomElement };
